import {
  createAsyncThunk,
  createSlice,
  createSelector,
} from '@reduxjs/toolkit';
import { Status } from 'utils/customTypes';
import { SLICE_STATUS } from 'utils/constants';
import yearTimePeriodAPI from './YearTimePeriodApi';
import { RootState } from 'state/store';

interface YearTimePeriodState {
  status: Status;
  years: Number[];
  timePeriods: {
    label: string;
    shortLabel: string;
  }[];
}

/* ============================= INITIAL STATE ============================== */

const initialState: YearTimePeriodState = {
  status: SLICE_STATUS.IDLE,
  years: [],
  timePeriods: [],
};

export const fetchYearTimePeriods = createAsyncThunk(
  'yearTimePeriod/FETCH_YEAR_TIME_PERIODS',
  async () => {
    const response = await yearTimePeriodAPI.fetchYearTimePeriods();
    return response;
  }
);

const yearTimePeriodSlice = createSlice({
  name: 'yearTimePeriod',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchYearTimePeriods.pending, (state) => {
        state.status = SLICE_STATUS.LOADING;
      })
      .addCase(fetchYearTimePeriods.fulfilled, (state, action) => {
        state.status = SLICE_STATUS.SUCCESS;
        state.years = action.payload.years.map((year: number) => Number(year));
        state.timePeriods = action.payload.timePeriods;
      })
      .addCase(fetchYearTimePeriods.rejected, (state) => {
        state.status = SLICE_STATUS.FAILED;
      });
  },
});

export const selectYears = createSelector(
  (state: RootState) => state.yearTimePeriod.years,
  (years) => years
);

export const selectTimePeriods = createSelector(
  (state: any) => state.yearTimePeriod?.timePeriods,
  (timePeriods) => timePeriods
);

export default yearTimePeriodSlice.reducer;
